<template>
    <v-row>
      <v-dialog v-model="showDialog" scrollable max-width="1140px" style="overflow:hidden">
        <v-skeleton-loader
        v-if="loading"
          type="article, actions"
        ></v-skeleton-loader>
        <v-card v-if="!loading">
          <v-card-title style="padding: 10px 0 0 10px; border-bottom: 1px solid rgba(0,0,0,.12);">
            <v-col cols="6" v-if="isNew">
                          <span style="font-size: 20px;">
                           {{ $t('wkt.admin.complaint.edit-window.title') }}
                          </span>
            </v-col>
            <v-col cols="6" v-if="!isNew">
                          <span style="font-size: 20px;">
                              {{ data.code }}
                          </span>
            </v-col>
            <!--<v-col cols="9" v-if="!isNew" style="text-align: end;">
                          <span style="font-size: 20px; padding-right:10px">
                              {{ data.creatorName }} - {{ data.companyName }}
                          </span>
            </v-col>-->
          </v-card-title>
          <v-card-text style="padding-bottom: 0;" >
            <v-container @wheel="onWheel">
               <v-form ref="form">
                  <v-row>
                     <!-- Fecha creacion -->
                     <v-col cols="3" v-if="!isNew">
                        <v-text-field
                        :value="formatDateTime(data.creationDate)"
                        :label="$t('wkt.admin.complaint.edit-window.creation_date')"
                        autocomplete="none"
                        disabled
                        />
                     </v-col>
                     <!-- Prioridad -->
                     <v-col cols="3">  
                        <v-text-field
                        v-if="isClosed"
                        :value="priorities.find(p => p.id === data.priority).name"
                        :label="$t('wkt.admin.complaint.edit-window.priority')"
                        autocomplete="none"
                        disabled
                        /> 
                        <v-select
                        v-if="!isClosed"
                        v-model="data.priority"
                        :items="priorities"
                        item-text="name"
                        item-value="id"
                        menu-props="bottom, offsetY"
                        :label="$t('wkt.admin.complaint.edit-window.priority')"
                        />
                     </v-col>
                     <!-- Estado -->
                     <v-col cols="3" v-if="!isNew">    
                        <v-text-field
                        v-if="isClosed"
                        :value="statuses.find(s => s.id === data.status).name"
                        :label="$t('wkt.admin.complaint.edit-window.status')"
                        autocomplete="none"
                        disabled
                        />
                        <v-select
                        v-if="!isClosed"
                        v-model="data.status"
                        :items="statuses"
                        item-text="name"
                        item-value="id"
                        menu-props="bottom, offsetY"
                        :label="$t('wkt.admin.complaint.edit-window.status')"
                        />
                     </v-col>
                     <!-- Gestor -->
                     <v-col cols="3" v-if="!isNew">    
                        <v-text-field
                        v-if="isClosed"
                        :value="`${data.assigneeFirstname} ${data.assigneeLastname}`"
                        :label="$t('wkt.admin.complaint.edit-window.assignee')"
                        autocomplete="none"
                        disabled
                        /> 
                        <v-autocomplete
                        v-if="!isClosed"
                        v-model="data.assigneeId"
                        :rules="[validationRules.required]"
                        :items="employees"
                        item-value="id"
                        :filter="filterEmployees"
                        menu-props="bottom, offsetY"
                        :label="$t('wkt.admin.complaint.edit-window.assignee')"
                        :placeholder="$t('wkt.admin.common.filters.employee_placeholder')">
                           <template v-slot:selection="{item}">
                              {{ `${getEmployeeFullname(item)}${!item.isEnabled ? ` (${$t('wkt.admin.edit-employee-window.disabled')})` : ''}` }}
                           </template>
                           <template v-slot:item="{item}">
                              {{ `${getEmployeeFullname(item)}${!item.isEnabled ? ` (${$t('wkt.admin.edit-employee-window.disabled')})` : ''}` }}
                           </template>
                        </v-autocomplete>
                     </v-col>
                     </v-row>

                     <v-card
                     elevation="0"
                     outlined>
                        <v-card-text>
                           <h3 class="mb-4">{{ $t('wkt.admin.complaint.edit-window.data') }}</h3>
                           <v-row class="pt-0 mt-0">
                              <!-- Ultima actualizacion -->
                              <v-col cols="3" v-if="!isNew" class="py-0">
                                 <v-text-field
                                 :value="formatDateTime(data.updateDate)"
                                 :label="$t('wkt.admin.complaint.edit-window.last_update')"
                                 autocomplete="none"
                                 disabled
                                 />
                              </v-col>
                              <!-- Fecha vencimiento -->
                              <v-col cols="3" v-if="!isNew" class="py-0">
                                 <v-text-field
                                 :value="formatDate(data.expirationDate)"
                                 :label="$t('wkt.admin.complaint.edit-window.expiration_date')"
                                 autocomplete="none"
                                 disabled
                                 />
                              </v-col>
                              <!-- Relacion empresa -->
                              <v-col cols="3" class="py-0">      
                                 <v-select
                                 v-model="data.companyRelationship"
                                 :items="relationships"
                                 item-text="name"
                                 item-value="id"
                                 menu-props="bottom, offsetY"
                                 return-object
                                 :label="$t('wkt.admin.complaint.edit-window.company_relationship')"
                                 :rules="[validationRules.required]"
                                 :disabled="!isNew"
                                 />
                              </v-col>
                              <!-- Responsable SII -->
                              <v-col cols="3" v-if="!isNew" class="py-0">     
                                 <v-text-field
                                 :value="`${data.managerFirstname} ${data.managerLastname}`"
                                 :label="$t('wkt.admin.complaint.edit-window.manager')"
                                 :disabled="!isNew"
                                 />
                              </v-col>
                           </v-row>
                           <v-row>
                              <!-- Nombre denunciante -->
                              <v-col cols="6" class="py-0">
                                 <v-text-field
                                 v-model="data.creatorFirstname"
                                 :rules="data.creatorFirstname?[validationRules.maxLength(data.creatorFirstname, 50)]:[]"
                                 :label="$t('wkt.admin.complaint.edit-window.creator_firstname')"
                                 autocomplete="none"
                                 :disabled="!isNew"
                                 />
                              </v-col>
                              <!-- Apellidos denunciante -->
                              <v-col cols="6" class="py-0">
                                 <v-text-field
                                 v-model="data.creatorLastname"
                                 :rules="data.creatorLastname?[validationRules.maxLength(data.creatorLastname, 100)]:[]"
                                 :label="$t('wkt.admin.complaint.edit-window.creator_lastname')"
                                 autocomplete="none"
                                 :disabled="!isNew"
                                 />
                              </v-col>
                              <!-- DNI denunciante -->
                              <v-col cols="3" class="py-0">
                                 <v-text-field
                                 v-model="data.creatorIdNumber"
                                 :rules="data.creatorIdNumber?[validationRules.cifnif(data.creatorIdNumber, country)]:[]"
                                 :label="$t('wkt.admin.complaint.edit-window.creator_id_number')"
                                 autocomplete="none"
                                 :disabled="!isNew"
                                 />
                              </v-col>
                              <!-- Telefono denunciante -->
                              <v-col cols="3" class="py-0">
                                 <v-text-field
                                 v-model="data.creatorPhone"
                                 :rules="data.creatorPhone?[validationRules.phone(data.creatorPhone, country)]:[]"
                                 :label="$t('wkt.admin.complaint.edit-window.creator_phone')"
                                 autocomplete="none"
                                 :disabled="!isNew"
                                 />
                              </v-col>
                              <!-- Email denunciante -->
                              <v-col cols="3" class="py-0">
                                 <v-text-field
                                 v-model="data.creatorEmail"
                                 :rules="data.creatorEmail?[validationRules.email]:[]"
                                 :label="$t('wkt.admin.complaint.edit-window.creator_email')"
                                 autocomplete="none"
                                 :disabled="!isNew"
                                 />
                              </v-col>
                           </v-row>
                           <v-row class="pt-0 mt-0">
                              <!-- Contacto permitido -->
                              <v-col cols="6">     
                                 <v-switch
                                 v-model="data.contactAllowed"
                                 :label="$t('wkt.admin.complaint.edit-window.contact_allowed')"
                                 :disabled="!isNew"
                                 />
                              </v-col>
                              <!-- Notificaciones permitidas -->
                              <v-col cols="6">     
                                 <v-switch
                                 v-model="data.notificationAllowed"
                                 :rules="[validationRules.emailRequired(data.notificationAllowed, data.creatorEmail)]"
                                 :label="$t('wkt.admin.complaint.edit-window.notification_allowed')"
                                 :disabled="!isNew"
                                 />
                              </v-col>
                           </v-row>
                           <v-row class="pt-0 mt-0">   
                              <!-- Hechos -->
                              <v-col cols="12">  
                                 <div class="d-flex">
                                    <h3>{{ $t('wkt.admin.complaint.edit-window.facts') }}</h3> <span v-if="isNew" style="margin-left: 3px; color: red;">*</span> <span v-if="isNew" style="margin-left: 10px;">{{ $t('wkt.admin.complaint.edit-window.facts_min_chars', [20]) }}</span>
                                 </div>
                                 <v-textarea
                                 v-model="data.facts"
                                 :rules="[validationRules.required]"
                                 :placeholder="$t('wkt.admin.complaint.new-message-window.write_your_message_here')"
                                 auto-grow
                                 rows="4"
                                 :disabled="!isNew" />
                              </v-col>
                              <!-- Archivos adjuntos -->
                              <v-col cols="12" v-if="isNew">       
                                 <v-file-input
                                 multiple chips truncate-length="45"
                                 :label="$t('wkt.admin.complaint.edit-window.attached_files')"
                                 v-model="files" />
                              </v-col>
                              <v-col cols="12" v-if="!isNew" class="pt-0 mt-0">       
                                 <h3>{{ $t('wkt.admin.complaint.edit-window.attached_files') }}</h3>
                                 <div v-if="files && files.length>0" class="pa-3">
                                    <div v-for="file in files" :key="file.id">
                                       <span @click="downloadDocument(file.id)" style="text-decoration: underline; cursor:pointer; color: #185EA9;">{{ file.documentName }}</span>
                                    </div>
                                 </div>
                              </v-col>
                              <!-- Notas internas -->
                              <v-col cols="12">   
                                 <h3>{{ $t('wkt.admin.complaint.edit-window.internal_notes') }}</h3>                 
                                 <v-textarea
                                 v-model="data.internalNotes"
                                 :placeholder="$t('wkt.admin.complaint.new-message-window.write_your_message_here')"
                                 auto-grow
                                 rows="3" />
                              </v-col>
                           </v-row> 
                        </v-card-text>
                     </v-card>

                     <v-row v-if="!isNew" style="margin-top: 15px">
                        <v-col cols="12">
                           <h3 style="margin-bottom: 15px; padding-left: 15px;">{{ $t('wkt.admin.complaint.edit-window.tracking') }}</h3>
                           <v-timeline dense class="mt-2">
                              <v-timeline-item v-for="message in messages" :key="message.id" small fill-dot>
                                 <v-card :color="message.creatorId ? '#E7EEF6' : ''" class="elevation-2">
                                    <div class="d-flex align-center justify-space-between py-2">
                                       <v-card-title class="py-0" style="font-size: 1.1rem;">
                                          {{ message.creatorId ? `${message.creatorLastname}, ${message.creatorFirstname}` : $t('wkt.admin.complaint.edit-window.complainant') }}
                                          <v-chip v-if="!message.isPublic" class="ma-2" x-small text-color="white" color="orange">Privado</v-chip>
                                       </v-card-title>
                                       <v-card-subtitle class="py-0 mt-0">
                                          {{formatDateTime(message.creationDate)}}
                                       </v-card-subtitle>
                                    </div>
                                    <v-card-text class="pt-0">
                                       <div v-html="message.message" />
                                       <div v-if="message.files && message.files.length>0">
                                          <div v-for="file in message.files" :key="file.id">
                                                <span @click="downloadMessageDocument(message.id,file.id)" class="text--primary" style="text-decoration: underline; cursor:pointer;">{{ file.documentName }}</span>
                                          </div>
                                       </div>
                                    </v-card-text>
                                 </v-card>
                              </v-timeline-item>
                           </v-timeline>
                        </v-col>
                     </v-row>
                  </v-form>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn v-if="data.id && !isClosed" color="#185EA9" :disabled="disableCreateMessage" @click="newMessage()" text>
                          <v-icon left>message</v-icon>
                          <span>{{ $t('wkt.admin.complaint.edit-window.new_message') }}</span>
                      </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="disableOKButton" color="#185EA9" text @click="onSave()" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.ok').toUpperCase() }}</v-btn>
            <v-btn text @click="showDialog=false" style="font-size: 0.9em; font-weight: 400;">{{ $t('wkt.admin.common.dialog-buttons.cancel').toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
          <ComplaintMessageDialog ref="newMessageDialog" @show-alert="$emit('show-alert', event)" @refresh="showDialog=true; loadComplaint(data.id)"/>
    </v-row>	
  </template>
  
<script>
import BaseModule from '../../common/BaseModule.js'
import CommonFormatter from '../../common/CommonFormatter.js'
import api from '../../../api/worktime'
import gwt from '../../../api/gwt'
import ComplaintMessageDialog from './components/ComplaintMessageDialog'

export default {
   name: 'ComplaintDialog',
   mixins: [BaseModule, CommonFormatter],
   components: {
      ComplaintMessageDialog
   },
   data() {
      return {
         showDialog: false,
         loading: true,
         creationDate: null,
         profile: null,
         company: null,
         country: null,
         data: {},
         employees: [],
         isNew: false,
         files: null,
         status: null,
         messages: [],
         relationships: [
            { id: 0, name: this.$t('wkt.admin.complaint.relationship-type.employee') },
            { id: 1, name: this.$t('wkt.admin.complaint.relationship-type.customer') },
            { id: 2, name: this.$t('wkt.admin.complaint.relationship-type.provider') },
            { id: 3, name: this.$t('wkt.admin.complaint.relationship-type.other') }
         ],
         priorities: [
            { id: 0, name: this.$t('wkt.admin.complaint.priority-type.very_low') },
            { id: 1, name: this.$t('wkt.admin.complaint.priority-type.low') },
            { id: 2, name: this.$t('wkt.admin.complaint.priority-type.medium') },
            { id: 3, name: this.$t('wkt.admin.complaint.priority-type.high') },
            { id: 4, name: this.$t('wkt.admin.complaint.priority-type.very_high') }
         ],
         statuses: [
            { id: 0, name: this.$t('wkt.admin.complaint.status-type.created') },
            { id: 1, name: this.$t('wkt.admin.complaint.status-type.on_hold') },
            { id: 2, name: this.$t('wkt.admin.complaint.status-type.in_progress') },
            { id: 3, name: this.$t('wkt.admin.complaint.status-type.dismissed') },
            { id: 4, name: this.$t('wkt.admin.complaint.status-type.closed') }
         ],
      }
   },
   computed: {
      canSendMessage() {
         if (!this.data.facts) {
            return false;
         }
         return this.data.facts.length >= 20;
      },
      isClosed() {
         if (!this.status) {
            return false;
         }
         return this.status >= 3;
      },
      disableCreateMessage() {
         return this.profile.moduleComplaint < 2;
      },
      disableOKButton() {
         console.log(`*** canSendMessage: ${this.canSendMessage}`);
         console.log(`*** isClosed: ${this.isClosed}`);
         console.log(`*** moduleComplaint < 2: ${this.profile.moduleComplaint < 2}`);
         return !this.canSendMessage || this.isClosed || this.profile.moduleComplaint < 2;
      }
   },
   methods: {
      onWheel(event) {
         event.stopPropagation();
      },
      newMessage() {
         this.showDialog = false;
         this.$refs.newMessageDialog.open(this.data.id);
      },
      downloadDocument(fileId) {
         api.downloadComplaintFile(this.data.companyId, this.data.id, fileId);
      },
      downloadMessageDocument(messageId, fileId) {
         api.downloadComplaintMessageFile(this.data.companyId, this.data.id, messageId, fileId);
      },
      open(action, payload) {
         this.status = null;
         this.showDialog = true;

         if (this.$refs.form) {
            this.$refs.form.resetValidation();
         }

         this.profile = gwt.getSessionProfile();
         this.company = gwt.getSessionInformation().company;
         this.getCountryById(this.company.countryId);
			this.getEmployees();

         this.messages = [];
         this.files = null;

         if (!payload) { // Estamos creando un elemento
            this.data = {
               contactAllowed: false,
               notificationAllowed: false,
               companyId: this.profile.companyId,
               priority: 2,
               status: 0
            };
            this.loading = false; 
            this.isNew = true;
            return;
         }

         this.loading = true;
         this.isNew = false;

         this.loadComplaint(payload);
      },
		getCountryById(countryId) {
			this.isLoading = true;

			api.getCountry(countryId,
				data => {
					this.isLoading = false;
					this.country = data;
				}, 
				error => {
					console.log(error);
					this.isLoading = false;
					this.doShowAlert({ text: error.message, color: 'error', timeout: 3000 });
				}
			);
		},
		getEmployees() {
			this.isLoading = true;
			this.employees = [];

			api.getStaff(
				data => {
					this.isLoading = false;
					this.getAllEmployees(data);
				}, 
				error => {
					console.log(error);
					this.isLoading = false;
					this.doShowAlert({ text: error.message, color: 'error', timeout: 3000 });
				}
			);
		},
		getAllEmployees(departments) {
			for (let i = 0; i < departments.length; i++) {
				this.employees = [...this.employees, ...departments[i].employees];
			}

			this.employees.sort((a,b) => {
				const fullnameA = this.getEmployeeFullname(a).toLowerCase();
				const fullnameB = this.getEmployeeFullname(b).toLowerCase();
				if (fullnameA == fullnameB) return 0;
				if (fullnameA > fullnameB) return 1;
				return -1;
			});
		},
		// eslint-disable-next-line no-unused-vars
		filterEmployees(item, queryText, itemText) {
			return item.firstname.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1 || 
				item.lastname.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1;
		},
      loadComplaint(complaintId) {
         api.getComplaint(complaintId, res => {
            this.status = res.status;
            this.data = res;
            
            //this.creationDate=this.data && this.data.creationDate ? this.formatDateTime(this.data.creationDate) : null;
            this.data.companyRelationship = this.relationships.find(r => r.id === this.data.companyRelationship);
            
            this.files = this.data.files;
            this.messages = res.messages;
            
            if (this.messages) {
               this.messages.sort(function(a, b) {
                  return new Date(b.creationDate) - new Date(a.creationDate);
               });
            }

            this.loading = false;
         }, error => {
            this.$emit('show-alert', { text: error, color: 'error', timeout: 3000 });
            this.loading = false;
         });
      },
      onSave() {
         if (!this.$refs.form.validate()) {
            return;
         }

         if (this.isNew) {
            this.createComplaint();
            return;
         }

         // Solo cuando cambiamos el estado a desestimada o cerrada
         if (this.data.status >= 3) {
            this.createLastMessage();
            return;
         }

         this.updateComplaint();
      },
      updateComplaint() {
         this.loading = true;

         const complaint = {
            id: this.data.id,
            creationDate: this.data.creationDate,
            expirationDate: this.data.expirationDate,
            managerId: this.data.managerId,
            assigneeId: this.data.assigneeId,
            code: this.data.code,
            accessToken: this.data.accessToken,
            creatorFirstname: this.data.creatorFirstname,
            creatorLastname: this.data.creatorLastname,
            creatorEmail: this.data.creatorEmail,
            creatorIdType: this.data.creatorIdType,
            creatorIdNumber: this.data.creatorIdNumber,
            creatorPhone: this.data.creatorPhone,
            companyRelationship: this.data.companyRelationship.id,
            status: this.data.status,
            priority: this.data.priority,
            contactAllowed: this.data.contactAllowed,
            notificationAllowed: this.data.notificationAllowed,
            facts: this.data.facts,
            internalNotes: this.data.internalNotes ? this.data.internalNotes : null,
            companyId: this.data.companyId,
            //updateDate: new Date().getTime()
         };

         this.loading = true;

         api.updateComplaint(complaint, res => {
            this.loading = false;
            if (res.id) {
               this.status = res.status;
               this.data = res;
               this.$emit('refresh');
               this.showDialog = false;
            } else {
               this.$emit('show-alert', { text: res.message, color: 'error', timeout: 3000 });
            }
         },
         error => {
            this.$log.error(error);
            this.loading = false;
            this.$emit('show-alert', { text: error, color: 'error', timeout: 3000 });
         });
      },
      createComplaint() {
         this.loading = true;
         let formData = new FormData();

         // files
         if (this.files) { 
            for (let file of this.files) {
               formData.append("file", file, file.name);
            }
         }

         if (this.data.creatorFirstname && this.data.creatorFirstname.trim().length > 0) {
            formData.append("creatorFirstname", this.data.creatorFirstname);
         }
         if (this.data.creatorLastname && this.data.creatorLastname.trim().length > 0) {
            formData.append("creatorLastname", this.data.creatorLastname);
         }
         if (this.data.creatorEmail && this.data.creatorEmail.trim().length > 0) {
            formData.append("creatorEmail", this.data.creatorEmail);
         }
         formData.append("creatorIdType", 0);
         if (this.data.creatorIdNumber && this.data.creatorIdNumber.trim().length > 0) {
            formData.append("creatorIdNumber", this.data.creatorIdNumber);
         }
         if (this.data.creatorPhone && this.data.creatorPhone.trim().length > 0) {
            formData.append("creatorPhone", this.data.creatorPhone);
         }
         formData.append("companyRelationship", this.data.companyRelationship.id);
         formData.append("priority", this.data.priority);
         formData.append("status", this.data.status);
         formData.append("contactAllowed", this.data.contactAllowed);
         formData.append("notificationAllowed", this.data.notificationAllowed);
         formData.append("facts", this.data.facts);
         if (this.data.internalNotes && this.data.internalNotes.trim().length > 0) {
            formData.append("internalNotes", this.data.internalNotes);
         }
         formData.append("companyId", this.data.companyId);

         this.loading = true;
         
         api.createComplaint(formData, res => {
            this.loading = false;
            if (res.id) {
               this.status = res.status;
               this.data = res;
               if (this.isNew) {
                  this.createFirstMessage();
               } else {
                  this.$emit('refresh');
                  this.showDialog = false;
               }
            } else {
               this.$emit('show-alert',{ text: res.message, color: 'error', timeout: 3000 });
            }
         },
         error => {
            this.$log.error(error);
            this.loading = false;
            this.$emit('show-alert',{ text: error, color: 'error', timeout: 3000 });
         });
      },
      createFirstMessage() {
         this.loading = true;
         let formData = new FormData();

         formData.append("complaintId", this.data.id);
         formData.append("isPublic", true);
         formData.append("message", this.$t('wkt.admin.complaint.first_message'));
         formData.append("sendEmail", false);

         api.createComplaintMessage(formData, res => {
            this.loading = false;
            if (res.id) {
               this.$emit('refresh');
               this.showDialog = false;
            } else {
               this.$emit('show-alert', { text: res.message, color: 'error', timeout: 3000 });
            }
         },
         error => {
            this.$log.error(error);
            this.loading = false;
            this.$emit('show-alert', { text: error, color: 'error', timeout: 3000 });
         });
      },
      createLastMessage() {
         // Solo si hemos cambiado el estado a desestimada o cerrada
         if (this.data.status < 3) {
            return;
         }

         const me = this;

         this.showDialog = false;
         this.$refs.newMessageDialog.open(this.data.id, this.data.status, () => {
            // Solo si hemos cambiado el estado a desestimada
            if (me.data.status === 3) {
               me.data.creatorFirstname = null;
               me.data.creatorLastname = null;
               me.data.creatorEmail = null;
               me.data.creatorIdNumber = null;
               me.data.creatorPhone = null;
            }

            me.updateComplaint();
         });
      },
   },
}
</script>